export default __webpack_public_path__ + "static/media/logo-xl-2048w.9bb2fab4.png";